import React, { useState } from "react";
import "./App.css";
import Cart from "./components/Cart";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";

import Context, { ShopContext } from "./components/Context";
import Thankyou from "./components/Thankyou";
import NavBar from "./components/NavBar";
import Product from "./components/Product";

function App() {
  const [data, setData] = useState([]);
  const childToParent = (item) => {
    setData(item);
  };
  return (
    <>
      <Context>
        <NavBar data={childToParent} />
        <Routes>
          <Route path="/" element={<Product item={data} />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/Thankyou" element={<Thankyou />} />
        </Routes>
      </Context>
    </>
  );
}

export default App;
